export const HELLO = 'HELLO'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js